import Link from "../../utils/Link";
import * as React from "react";
import useTranslations from "../../../hooks/useTranslations";
import { ReviewIcon } from "../../icons";
import Activity from "../ActivityPlate";
import { Text } from "@chakra-ui/react";
import {
  ActivityFragment,
  CampaignSummaryFragment,
  ReviewMinimalFragment,
} from "../../../graphql/generated/definitions";

type ReviewUpdatedActivity = ActivityFragment & {
  recipient: CampaignSummaryFragment;
  trackable: ReviewMinimalFragment;
};

export function isReviewUpdatedActivity(
  q: ActivityFragment
): q is ReviewUpdatedActivity {
  return q.key === "review.updated";
}

interface ReviewUpdatedActivityProps {
  activity: ReviewUpdatedActivity;
}

export const ReviewUpdatedActivity: React.FC<ReviewUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="reviewUpdatedActivity"
      visual={<ReviewIcon className="w-10 h-10 text-accent-500" />}
    >
      <Text fontSize="sm">
        {t("activity.labels.reviewUpdated", {
          review: (
            <Link to={`/reviews/${activity.trackable.id}`}>
              {t("activity.objects.review")}
            </Link>
          ),
          collaborator: activity.trackable.collaborator.name,
        })}
      </Text>
    </Activity>
  );
};
